import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Divider,
    Stack,
    Flex,
    Text,
    useMultiStyleConfig,
    useBreakpointValue,
} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import PaymentIcons from '../payment-icons'
import SocialIcons from '../../social-icons'
import {BrandLogo} from '../../icons'
import CountrySelector from '../country-selector'
import LegalLinks from '../legal-links'
import ApplicationIcons from '../application-icons'

const CopyrightSection = ({data}) => {
    const styles = useMultiStyleConfig('Footer')

    const intl = useIntl()

    const footerData = data?.footer_bottom_group

    const copyrightGroup = footerData?.copyright_group
    const copyright = copyrightGroup?.copyright
    const vatNumber = copyrightGroup?.vat_number

    const breakpoint = useBreakpointValue({
        base: 'sm',
        lg: 'lg',
    })

    return (
        <>
            {breakpoint === 'lg' && (
                <Box w="100%" {...styles.hideOnMobile}>
                    <Divider {...styles.dividerRule} {...styles.kenwoodDividerRule} />
                    <Flex {...styles.paymentsLegal}>
                        <Stack {...styles.countryPayments}>
                            <Flex {...styles.brandCountry}>
                                <BrandLogo
                                    data-testid="brand-logo"
                                    inverted={true}
                                    {...styles.footerBrand}
                                />

                                <Text {...styles.copyright} data-testid="copyright">
                                    {`${copyright} ${vatNumber}`}
                                </Text>
                            </Flex>
                        </Stack>
                        <Stack {...styles.socialAppPrivacy}>
                            <Flex {...styles.socialApp}>
                                <SocialIcons
                                    data-testid="social-icons"
                                    icons={footerData?.social_icons}
                                />

                                <ApplicationIcons icons={footerData?.app_download_icons} />
                            </Flex>
                        </Stack>
                        <Stack {...styles.socialAppPrivacy}>
                            <PaymentIcons
                                data-testid="payment-icons"
                                icons={footerData?.payment_icons}
                            />
                        </Stack>
                    </Flex>
                    <Divider {...styles.dividerRule} {...styles.kenwoodDividerRule} />
                    <Stack {...styles.copyBox}>
                        <CountrySelector intl={intl} />
                        <Box w="100%" {...styles.copyPositioning}>
                            <LegalLinks
                                variant="horizontal"
                                data-testid="legal-links"
                                links={copyrightGroup?.copyright_links}
                            >
                                <Text as="div" id="teconsent" sx={styles.teconsent}></Text>
                            </LegalLinks>
                        </Box>
                    </Stack>
                </Box>
            )}
            {breakpoint === 'sm' && (
                <Box w="100%" {...styles.hideOnDesktop}>
                    <Stack {...styles.mobileStack} {...styles.mobileContainer}>
                        <SocialIcons data-testid="social-icons" icons={footerData?.social_icons} />
                        <PaymentIcons
                            data-testid="payment-icons"
                            icons={footerData?.payment_icons}
                        />
                        <CountrySelector intl={intl} />
                        {/* <ApplicationIcons icons={footerData?.app_download_icons} /> */}
                        <Box w="100%" {...styles.copyPositioning}>
                            <LegalLinks
                                variant="horizontal"
                                data-testid="legal-links"
                                links={copyrightGroup?.copyright_links}
                            >
                                <Text as="div" id="teconsent" sx={styles.teconsent}></Text>
                            </LegalLinks>
                        </Box>
                        <Flex {...styles.kenwoodCopyrightBrand}>
                            <BrandLogo
                                data-testid="brand-logo"
                                inverted={true}
                                {...styles.footerBrand}
                            />
                            <Text data-testid="copyright" {...styles.copyright}>
                                {`${copyright} ${vatNumber}`}
                            </Text>
                        </Flex>
                    </Stack>
                </Box>
            )}
        </>
    )
}

CopyrightSection.propTypes = {
    data: PropTypes.shape({
        footer_bottom_group: PropTypes.shape({
            copyright_group: PropTypes.shape({
                copyright: PropTypes.string,
                vat_number: PropTypes.string,
                copyright_links: PropTypes.array,
            }),
            payment_icons: PropTypes.array,
            social_icons: PropTypes.array,
            app_download_icons: PropTypes.array,
        }),
    }),
}

export default CopyrightSection
